import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import { PAGE_COUNT } from "./userManagement/helper";
import { get } from "lodash";

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      minRange: 0,
      maxRange: get(props, "limit", 0)
    };
  }

  handlePageChange = data => {
    const { onPageChange, limit } = this.props;
    typeof onPageChange === "function" &&
      onPageChange({
        ...data,
        minRange:
          (limit && limit * data.selected) || PAGE_COUNT * data.selected,
        maxRange:
          (limit && limit * data.selected + limit) ||
          PAGE_COUNT * data.selected + PAGE_COUNT
      });
  };

  render() {
    const { pageCount, offset } = this.props;
    return (
      pageCount > 1 && (
        <ReactPaginate
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={this.handlePageChange}
          containerClassName={"pagination align-centre"}
          pageLinkClassName={"page"}
          activeLinkClassName={"active"}
          forcePage={offset}
        />
      )
    );
  }
}

export default Pagination;
